import React from "react"
import "./home.scss"

import Layout from "../components/layout"
import AboutCard from "../containers/about_card"
import FeatureCard from "../containers/feature_card"

import SEO from "../components/seo"

import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Button from "react-bootstrap/Button"
import Card from "react-bootstrap/Card"

const spotlight = [
  {
    title: "The Case for Women In Tech",
    subtitle: "Op-Ed",
    date: "Jul 2020",
    link:
      "https://medium.com/better-programming/the-case-for-women-in-tech-a-singaporean-perspective-ee1e74a23371",
    description:
      "A lot of articles online about women in tech are US-centric, so I wanted to explore the issue in the local context. My piece is now published under Better Programming on Medium",
  },
  {
    title: "react-audio-element",
    subtitle: "npm package",
    date: "Aug 2020",
    link: "https://www.npmjs.com/package/react-audio-element",
    description:
      "npm package that provides a styleable alternative to the HTML5 audio element, by recreating it in canvas",
  },
  {
    title: "Voice Activated Photobooth",
    subtitle: "website",
    date: "Aug 2020",
    link: "https://picovoice.ai/selfie/",
    description:
      "Take pictures and apply filters, like you do on instagram. But with this application, you do not have to use your hands at all. This is a fully voice activated application that runs on the browser. I recreated all the filters using the Canvas API. The voice engine is a WASM module that runs on a Web Worker.",
  },
]

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <div className="home">
      <div className="background"></div>
      <Container className="about">
        <Row>
          <Col md={6}>
            <AboutCard />
          </Col>
          <Col md={6}>
            <br />
            <h1 className="shout">Hello</h1>
            <h2 className="caption">
              I'm a Software Engineer based in Singapore
            </h2>
            <br />
            <Button href="/work">Work</Button> &nbsp;&nbsp;&nbsp;
            <Button variant="secondary" href="/projects">
              Projects
            </Button>
            <div className="writeup">
              I'm a Year 4 student currently studying CS as part of the
              Renaissance Engineering Programme at Nanyang Technological
              University. I'm interested in software engineering, with
              experience in creating web applications and high proficiency in
              front end, browser technologies. I've interned at Palantir, Stripe
              and a bunch more companies.
            </div>
          </Col>
        </Row>
        <h1>Spotlight</h1>
        <Row className="mt-0">
          {spotlight.map(item => (
            <Col xs={12} md={4}>
              <FeatureCard {...item} />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  </Layout>
)

export default IndexPage
